import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Representative } from 'src/app/shared/models/dtos/register-form/representative/representative';
import { InviteRepresentativeResponseDTO } from 'src/app/shared/models/dtos/responses/invite-representative-response-dto/invite-representative-response-dto';
import { GeneralizedRepresentative } from 'src/app/shared/models/generalized-representative/generalized-representative';
import { RepresentativeItemLabels } from 'src/app/shared/models/representative-item-labels/representative-item-labels';

@Component({
  selector: 'app-representative-list',
  templateUrl: './representative-list.component.html',
  styleUrls: ['./representative-list.component.scss'],
})
/**
 * Accordeon item that show business representatives
 */
export class RepresentativeListComponent {
  @Input() generalizedRepresentativeList?: GeneralizedRepresentative[] = [];
  @Input() expiredTip?: string;
  @Output() promote = new EventEmitter<Representative>();
  @Output() remove = new EventEmitter<GeneralizedRepresentative>();
  @Output() resendInvite = new EventEmitter<InviteRepresentativeResponseDTO>();
  @Input() labels!: RepresentativeItemLabels;
  @Input() canTamper?: boolean;
  @Input() isSummary?: boolean;
  @Input() isSingleAdmin!: boolean;

  /**
   * @param {Representative} representative
   */
  doPromote(representative: Representative) {
    this.promote.emit(representative);
  }

  /**
   * @param {InviteRepresentativeResponseDTO} invitee
   */
  doResendInvite(invitee: InviteRepresentativeResponseDTO) {
    this.resendInvite.emit(invitee);
  }

  /**
   * @param {GeneralizedRepresentative} generalizedRepresentative
   */
  doRemove(generalizedRepresentative: GeneralizedRepresentative) {
    this.remove.emit(generalizedRepresentative);
  }
}
